import {ChevronDownIcon, ChevronUpIcon, Divider} from 'native-base';
import {H3Text, H6Text} from '@buncha/components/core/text';
import React, {useCallback} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Accordian} from '@buncha/components/composites';
import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import {Box} from '@buncha/components/core/view';
import {Linking} from 'react-native';
import {Modules} from '@buncha/utils/types';
import {styles} from './style';
import {useGetLocale} from '@buncha/localization/hooks';

const Faqs = () => {
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  const {title, body} =
    useGetLocale(Modules.B2BUserOrder, B2BUserScreens.OrderInfo) ?? {};

  const callHandler = useCallback((phoneNumber: string) => {
    if (!phoneNumber) return;
    const formatted = phoneNumber.replace(/[^0-9]/g, ''); // sanitize
    Linking.openURL(`tel:+${formatted}`);
  }, []);

  const renderBody = (text: string) => {
    const phoneRegex = /(\+?\d[\d\s\-()\u2011\u2013\u2014]{7,}\d)/g;
    const match = text.match(phoneRegex);

    if (match) {
      const phoneNumber = match[0];
      const parts = text.split(phoneNumber);

      return (
        <H6Text
          style={[
            styles.leftAlign,
            styles.body,
            {fontFamily: muliFont[700].normal},
          ]}>
          {parts[0]}
          <H6Text
            onPress={() => callHandler(phoneNumber)}
            style={[
              styles.phoneNumber,
              {
                color: theme?.text.blue[100],
              },
            ]}>
            {phoneNumber}
          </H6Text>
          {parts[1]}
        </H6Text>
      );
    }

    return (
      <H6Text
        style={[
          styles.leftAlign,
          styles.body,
          {fontFamily: muliFont[700].normal},
        ]}>
        {text}
      </H6Text>
    );
  };

  return (
    <Box style={styles.container}>
      <H3Text style={[styles.leftAlign, {color: theme?.text.blue[300]}]}>
        {title?.faq}
      </H3Text>
      {body?.faq?.map?.((faq: {header: string; body: string}, idx: number) => (
        <Box key={idx} style={styles.itemContainer}>
          <Accordian
            header={
              <H6Text
                style={[
                  styles.leftAlign,
                  {
                    fontFamily: muliFont[700].normal,
                    color: theme?.text.blue[300],
                  },
                ]}>
                {faq?.header}
              </H6Text>
            }
            style={styles.accordion}
            iconEnable={
              <Box style={styles.iconBox}>
                <ChevronUpIcon color={theme?.text.blue[300]} />
              </Box>
            }
            iconDisable={
              <Box style={styles.iconBox}>
                <ChevronDownIcon color={theme?.text.blue[300]} />
              </Box>
            }>
            {renderBody(faq?.body)}
          </Accordian>
          <Divider />
        </Box>
      ))}
    </Box>
  );
};

export default React.memo(Faqs);
